import React from 'react';
import { useFormikContext, getIn } from 'formik';

import ListWithPropertiesBlock from './ListWithPropertiesBlock';

const ListWithPropertiesBlockContainer = (props: any) => {
  const { values, setFieldValue } = useFormikContext();

  const handleKeyDown = (event: any, itemIndex: any) => {
    if (event.key === 'Enter') {
      const items = [...getIn(values, `${props.namePrefix}.data`)];

      items.splice(itemIndex + 1, 0, '');

      setFieldValue(`${props.namePrefix}.data`, items);
    }

    if (event.key === 'Backspace') {
      const currentItemValue = getIn(
        values,
        `${props.namePrefix}.data[${itemIndex}]`,
      );

      if (!currentItemValue && itemIndex !== 0) {
        const items = [...getIn(values, `${props.namePrefix}.data`)];

        items.splice(itemIndex, 1);

        setFieldValue(`${props.namePrefix}.data`, items);
      }
    }
  };

  return <ListWithPropertiesBlock {...props} onKeyDown={handleKeyDown} />;
};

export default React.memo(ListWithPropertiesBlockContainer) as any;
